import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './app/globals.css'
import { CurrencyProvider } from '@/lib/currency'
import AutoLogoutProvider from '@/components/AutoLogoutProvider'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <CurrencyProvider>
        <AutoLogoutProvider>
          <App />
        </AutoLogoutProvider>
      </CurrencyProvider>
    </BrowserRouter>
  </React.StrictMode>,
)

